module.exports = __webpack_public_path__ + "img/elaiolado.6843b28e.jpg";